"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTrackLiked = void 0;
const auth_1 = require("../../api/auth");
function isTrackLiked(trackData) {
    for (const like of trackData.likes) {
        if (like.username === auth_1.username) {
            return true;
        }
    }
    return false;
}
exports.isTrackLiked = isTrackLiked;
